$(document).ready(function () {
	$(window).on("load", function () {
		var params = location.href.split("variant=");
		if (params[1]) {
			changevalimg();
		}
	});
	$(".customMedia ul.thumb li").on("click", function () {
		$(".customMedia ul.thumb li").removeClass("is-active");
		$(this).addClass("is-active");
		var pos = $(this).data("media-position");
		$(".customMedia ul.stage li").removeClass("is-active");
		$(".customMedia ul.stage li[data-media-position=" + pos + "]").addClass(
			"is-active"
		);
	});

	$(document).on("change", 'input[type="radio"]', function () {
		if ($(this).is(":checked")) {
			changevalimg();
		}
	});

	function changevalimg() {
		var imgurl = $(".ant-radio-wrapper-checked")
			.find("img")
			.attr("src")
			.split("v=");
		var valimg;
		$(".customMedia ul.thumb li").each(function () {
			var cimg = $(this).find("img").attr("src").split(/&|v=/);
			if (cimg[1] == imgurl[1]) {
				valimg = $(this);
			}
		});
		$(".customMedia ul.thumb li").removeClass("is-active");
		valimg.addClass("is-active");
		var pos = valimg.data("media-position");
		$(".customMedia ul.stage li").removeClass("is-active");
		$(".customMedia ul.stage li[data-media-position=" + pos + "]").addClass(
			"is-active"
		);
		var targetPosition = valimg.offset().top; // liの位置を取得
		var ulPosition = $(".customMedia .thumbArea").offset().top; // ulの位置を取得
		var scrollPosition = targetPosition - ulPosition; // ul内でのスクロール位置を計算

		$(".customMedia .thumbArea").animate(
			{
				scrollTop: scrollPosition,
			},
			0
		);
	}
});
